import { messagedCall, post } from '.';

export const runInvestmentsTest = async () =>
  messagedCall(
    post('testInvestments'),
    'runInvestmentTestLoading',
    'runInvestmentTestSuccess',
    'runInvestmentTestError'
  );
